import OldMutualLandingPage from './OldMutual/LandingPage';

/**
 * Registry mapping subdomain keys to partner landing page components.
 *
 * To add a new partner:
 *   1. Create src/containers/Login/PartnerLandingPages/<Name>/LandingPage.js
 *   2. Import it above and add a key entry below.
 *      The key must match the first subdomain segment (lowercase).
 *
 * Example: oldmutual.inclusivity-aspin.com  →  key: 'oldmutual'
 */
const registry = {
  oldmutual: OldMutualLandingPage,
};

export default registry;
